import { AUTH_ID, AUTH_ROLE, COMPANY_ID, COMPANY_NAME, COMPANY_UUID } from '../../constants/auth.constants';
import { AVATAR, LANGUAGE, LANGUAGE_ID } from '../../constants/localstorage.constants';
import { getFromLocalStorage } from '../../utils/storage.util';

export function getLoggedCompanyId(): number {
	return +getFromLocalStorage(COMPANY_ID)!;
}

export function getLoggedCompanyName(): string {
	return getFromLocalStorage(COMPANY_NAME)!;
}

export function getLoggedCompanyUuid(): string {
	return getFromLocalStorage(COMPANY_UUID)!;
}

export function getLoggedUserId(): number {
	return +getFromLocalStorage(AUTH_ID)!;
}

export function getLoggedUserRole(): string {
	return getFromLocalStorage(AUTH_ROLE) ?? '';
}

export function getLoggedAvatar(): string {
	return getFromLocalStorage(AVATAR) ?? '';
}

export function getLanguage(): string {
	return getFromLocalStorage(LANGUAGE) ?? 'it';
}

export function getLanguageId(): number {
	return getFromLocalStorage(LANGUAGE_ID) ? +getFromLocalStorage(LANGUAGE_ID)! : 1;
}
